import { ReportUpsertParams } from "@suns/api/generated-client/apollo";

export const PlayerPosition = ReportUpsertParams.position;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type PlayerPosition = ReportUpsertParams.position;
